import { COLORS } from "../constants";

export type Palette = {
  BASE_COLOR: string;
  BRAND: {
    PRIMARY: string;
    PRIMARY_LIGHT: string;
    SECONDARY: string;
  };
  PRIMARY: {
    //backgrounds
    PRIMARY_SUPER_DARK: string;
    PRIMARY_DARK: string;
    //interactive components
    PRIMARY_MEDIUM: string;
    //borders and seperators
    PRIMARY_MEDIUM_LIGHT: string;
    //solid colors
    PRIMARY_LIGHT: string;
    //accessible text
    PRIMARY_LIGHTEST: string;
    PRIMARY_SUPER_LIGHT: string;
  };
  SECONDARY: {
    SECONDARY_SUPER_DARK: string;
    SECONDARY_DARK: string;
    SECONDARY_MEDIUM: string;
    SECONDARY_MEDIUM_LIGHT: string;
    SECONDARY_LIGHT: string;
    SECONDARY_LIGHTEST: string;
    SECONDARY_SUPER_LIGHT: string;
  };
  SUCCESS: {
    SUCCESS_DARK: string;
    SUCCESS_MEDIUM: string;
    SUCCESS_LIGHT: string;
    SUCCESS_SUPER_LIGHT: string;
  };
  WARNING: {
    WARNING_DARK: string;
    WARNING_MEDIUM: string;
    WARNING_LIGHT: string;
    WARNING_SUPER_LIGHT: string;
  };
  DANGER: {
    DANGER_SUPER_DARK: string;
    DANGER_DARK: string;
    DANGER_MEDIUM: string;
    DANGER_LIGHT: string;
    DANGER_SUPER_LIGHT: string;
  };
};

export const DEFAULT_WHITE_BACKGROUND = "#ffffff";

export const LIGHT_MODE: Palette = {
  BASE_COLOR: DEFAULT_WHITE_BACKGROUND,
  BRAND: {
    PRIMARY: COLORS.BRAND.PRIMARY,
    PRIMARY_LIGHT: COLORS.BRAND.PRIMARY_LIGHT,
    SECONDARY: COLORS.BRAND.SECONDARY,
  },
  PRIMARY: {
    PRIMARY_SUPER_DARK: COLORS.GRAYSCALE.GRAY_SUPER_DARK,
    PRIMARY_DARK: COLORS.GRAYSCALE.GRAY_DARK,
    PRIMARY_MEDIUM: COLORS.GRAYSCALE.GRAY_MEDIUM,
    PRIMARY_MEDIUM_LIGHT: COLORS.GRAYSCALE.GRAY_MEDIUM_LIGHT,
    PRIMARY_LIGHT: COLORS.GRAYSCALE.GRAY_LIGHT,
    PRIMARY_LIGHTEST: COLORS.GRAYSCALE.GRAY_LIGHTEST,
    PRIMARY_SUPER_LIGHT: COLORS.GRAYSCALE.GRAY_SUPER_LIGHT,
  },
  SECONDARY: {
    SECONDARY_SUPER_DARK: COLORS.SECONDARY.SUPER_DARK,
    SECONDARY_DARK: COLORS.SECONDARY.DARK,
    SECONDARY_MEDIUM: COLORS.SECONDARY.MEDIUM,
    SECONDARY_MEDIUM_LIGHT: COLORS.SECONDARY.MEDIUM_LIGHT,
    SECONDARY_LIGHT: COLORS.SECONDARY.LIGHT,
    SECONDARY_LIGHTEST: COLORS.SECONDARY.LIGHTEST,
    SECONDARY_SUPER_LIGHT: COLORS.SECONDARY.SUPER_LIGHT,
  },
  SUCCESS: {
    SUCCESS_DARK: COLORS.SUCCESS.DARK,
    SUCCESS_MEDIUM: COLORS.SUCCESS.MEDIUM,
    SUCCESS_LIGHT: COLORS.SUCCESS.LIGHT,
    SUCCESS_SUPER_LIGHT: COLORS.SUCCESS.SUPER_LIGHT,
  },
  WARNING: {
    WARNING_DARK: COLORS.WARNING.DARK,
    WARNING_MEDIUM: COLORS.WARNING.MEDIUM,
    WARNING_LIGHT: COLORS.WARNING.LIGHT,
    WARNING_SUPER_LIGHT: COLORS.WARNING.SUPER_LIGHT,
  },
  DANGER: {
    DANGER_SUPER_DARK: COLORS.DANGER.SUPER_DARK,
    DANGER_DARK: COLORS.DANGER.DARK,
    DANGER_MEDIUM: COLORS.DANGER.MEDIUM,
    DANGER_LIGHT: COLORS.DANGER.LIGHT,
    DANGER_SUPER_LIGHT: COLORS.DANGER.SUPER_LIGHT,
  },
};

export const DEFAULT_BLACK_BACKGROUND = "#121212";

export const DARK_MODE: Palette = {
  BASE_COLOR: DEFAULT_BLACK_BACKGROUND,
  BRAND: {
    PRIMARY: COLORS.BRAND.PRIMARY,
    PRIMARY_LIGHT: COLORS.BRAND.PRIMARY_LIGHT,
    SECONDARY: COLORS.BRAND.SECONDARY,
  },
  PRIMARY: {
    PRIMARY_SUPER_DARK: COLORS.DARK_GRAYSCALE.GRAY_SUPER_DARK,
    PRIMARY_DARK: COLORS.DARK_GRAYSCALE.GRAY_DARK,
    PRIMARY_MEDIUM: COLORS.DARK_GRAYSCALE.GRAY_MEDIUM,
    PRIMARY_MEDIUM_LIGHT: COLORS.DARK_GRAYSCALE.GRAY_MEDIUM_LIGHT,
    PRIMARY_LIGHT: COLORS.DARK_GRAYSCALE.GRAY_LIGHT,
    PRIMARY_LIGHTEST: COLORS.DARK_GRAYSCALE.GRAY_LIGHTEST,
    PRIMARY_SUPER_LIGHT: COLORS.DARK_GRAYSCALE.GRAY_SUPER_LIGHT,
  },
  SECONDARY: {
    SECONDARY_SUPER_DARK: COLORS.DARK_SECONDARY.SECONDARY_SUPER_DARK,
    SECONDARY_DARK: COLORS.DARK_SECONDARY.SECONDARY_DARK,
    SECONDARY_MEDIUM: COLORS.DARK_SECONDARY.SECONDARY_MEDIUM,
    SECONDARY_MEDIUM_LIGHT: COLORS.DARK_SECONDARY.SECONDARY_MEDIUM_LIGHT,
    SECONDARY_LIGHT: COLORS.DARK_SECONDARY.SECONDARY_LIGHT,
    SECONDARY_LIGHTEST: COLORS.DARK_SECONDARY.SECONDARY_LIGHTEST,
    SECONDARY_SUPER_LIGHT: COLORS.DARK_SECONDARY.SECONDARY_SUPER_LIGHT,
  },
  DANGER: {
    DANGER_SUPER_DARK: COLORS.DANGER.SUPER_DARK,
    DANGER_DARK: COLORS.DANGER.DARK,
    DANGER_MEDIUM: COLORS.DANGER.MEDIUM,
    DANGER_LIGHT: COLORS.DANGER.LIGHT,
    DANGER_SUPER_LIGHT: COLORS.DANGER.SUPER_LIGHT,
  },
  SUCCESS: {
    SUCCESS_DARK: COLORS.SUCCESS.DARK,
    SUCCESS_MEDIUM: COLORS.SUCCESS.MEDIUM,
    SUCCESS_LIGHT: COLORS.SUCCESS.LIGHT,
    SUCCESS_SUPER_LIGHT: COLORS.SUCCESS.SUPER_LIGHT,
  },
  WARNING: {
    WARNING_DARK: COLORS.WARNING.DARK,
    WARNING_MEDIUM: COLORS.WARNING.MEDIUM,
    WARNING_LIGHT: COLORS.WARNING.LIGHT,
    WARNING_SUPER_LIGHT: COLORS.WARNING.SUPER_LIGHT,
  },
};
